import { elgigantentheme } from '@jotta/ui/themes/elgiganten'
import { startApp } from '../App'

startApp(elgigantentheme)
